import Axios from 'axios';
import reduxStore from 'redux/store'
import HttpCodes from 'constants/HttpCodes';
import RouterPath from './RouterPath';
import querystring from 'querystring'
import downloadFile from './downloadFile';
import {setResource, setSaveStatusError} from 'redux/actions';
import Tr from 'translations/Translations';
import Endpoints from 'constants/Endpoints';
import {Sema as semaphore} from 'async-sema';
import moment from 'moment';

const _sem = new semaphore(1);

const _refreshSessionTime = () => {
	const state = reduxStore.getState();
	const sessionTime = state.resources.sessionTime;
	if (sessionTime) {
		const endTime = moment().add(sessionTime.time, 's')
		reduxStore.dispatch(setResource('sessionTime', {
			time: sessionTime.time,
			endTime
		}))
	}
}

const _paramsSerializer = (params) => {
	return querystring.stringify(params)
}

const _executeRequest = async ({ headers, ...params }) => {
	let auth = JSON.parse(localStorage.getItem("authorize"))
	const request = await Axios({
		headers: {
			'Authorization': 'Bearer ' + auth.access_token,
			...headers,
		},
		...params,
		paramsSerializer: _paramsSerializer,
	});
	_refreshSessionTime();
	return request;
}

const _logout = (url) => {
	localStorage.removeItem('authorize');
	const location = window.location;
	const search = location.search
	const params = querystring.parse(search.substr(1))
	let state = params['state'];
	if (!state) {
		state = window.btoa(location.pathname + location.search);
	}

	const redUrl = url ? url : RouterPath.BUYER_INIT + '?' + querystring.stringify({
		state
	})
	window.location.href = redUrl;
}

export const SoftLogout = async (url) => {
	try {
		await _logout(url);
	} catch (error) {
		throw error;
	}
}

const _refresToken = async () => {
	const auth = JSON.parse(localStorage.getItem("authorize"))
	try {
		console.info("RestRequest - refreshing token...");
		const res = await Axios({
			method: 'post',
			url: Endpoints.oauth.TOKEN,
			params: {
				client_id: 'mp',
				grant_type: 'refresh_token',
				refresh_token: auth.refresh_token
			},
		});
		localStorage.setItem("authorize", JSON.stringify(res.data))
	} catch (error) {
		throw error;
	}
}
export const RefreshToken = async () => {
	try {
		await _refresToken();
	} catch (error) {
		throw error;
	}
}

const _restRequest = async (args) => {
	await _sem.acquire();
	try {
		return await _executeRequest(args);
	} catch (error) {
		const response = error.response;

		switch (response.status) {
			case HttpCodes.UNAUTHORIZED:
				try {
					await _refresToken();
					return await _executeRequest(args);
				} catch (error) {
					_logout();
				}
				break;
			case HttpCodes.FORBIDDEN:
                const state = reduxStore.getState();
                if (!!state?.resources?.userData?.contractorUser) {
                    reduxStore.dispatch(setSaveStatusError(Tr('forbidden_error_contractor')));
                } else {
				    reduxStore.dispatch(setSaveStatusError(Tr('forbidden_error')));
                }
				throw error;
			case HttpCodes.BAD_REQUEST:
				reduxStore.dispatch(setSaveStatusError(Tr('bad_request_error')));
				throw error;
			case HttpCodes.NOT_FOUND:
				reduxStore.dispatch(setSaveStatusError(Tr('not_found_request_error')));
				throw error;
			case HttpCodes.INTERNAL_SERVER_ERROR:
				reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
				throw error;
			default:
				throw error;
		}
	} finally {
		_sem.release()
	}
}

const RestRequest = async (params) => {
	const res = await _restRequest(params);
	return res.data;
}

export const RestRequestGET = async (url, other) => RestRequest({ url, method: 'get', ...other });
export const RestRequestDELETE = async (url, other) => RestRequest({ url, method: 'delete', ...other });
export const RestRequestPOST = async (url, data, other) => RestRequest({ url, data, method: 'post', ...other });
export const RestRequestPUT = async (url, data, other) => RestRequest({ url, data, method: 'put', ...other });

export const RestRequestBLOB = async (url, other, method) => {
	const res = await _restRequest({
		url,
		method: !!method ? method : 'get',
		responseType: 'blob',
		...other
	});

	const type = res.headers['content-type'];
	if(type.startsWith("application/json")) {
		const ob = JSON.parse(await res.data.text());
		if(ob.success === false) {
			return ob;
		}
	}

	const contentDisposition = res.headers['content-disposition'];
	let name = contentDisposition.indexOf("filename*=") >= 0
		? contentDisposition.split("filename*=")[1]
		: contentDisposition.split("filename=")[1];
	name = decodeURIComponent(name);
	const fileUrl = window.URL.createObjectURL(
		new Blob([res.data], { type })
	)
	downloadFile({ url: fileUrl, name })
	window.URL.revokeObjectURL(fileUrl)
}

export const RestRequestBLOBBase64Encoded = async (url, other) => {
	const res = await _restRequest({
		url,
		method: 'get',
		responseType: 'blob',
		...other
	});

	const type = res.headers['content-type'];
	if(type.startsWith("application/json")) {
		const ob = JSON.parse(await res.data.text());
		if(ob.success === false || ob.success === true) {
			return ob;
		}
	}
	const b64 = await blobToBase64(res.data)

	const result = {"success":true,
		"result":b64.split(",")[1],
        "errors":null
    }

	return result;

}

function blobToBase64(blob) {
	return new Promise((resolve, _) => {
		const reader = new FileReader();
		reader.onloadend = () => resolve(reader.result);
		reader.readAsDataURL(blob);
	});
}

export default RestRequest;